<!-- This is a generic toaster to work from everywhere -->
<c-toaster class="p-3" position="fixed"></c-toaster>

<router-outlet />